import React, { useState, useEffect, useCallback } from 'react';
import {
  Box, Typography, Paper, Table, TableBody, TableCell, TableContainer, TableHead,
  TableRow, Button, CircularProgress, Alert, Chip, Stack,
} from '@mui/material';
import { ReportProblem as ProblemIcon, Refresh as RefreshIcon, CheckCircle as OkIcon } from '@mui/icons-material';
import axios from '../api/axios';

const SEV = {
  high:   { label: 'Высокая',  color: 'error' },
  medium: { label: 'Средняя',  color: 'warning' },
  low:    { label: 'Низкая',   color: 'info' },
  info:   { label: 'Инфо',     color: 'default' },
};
const ORDER = ['high', 'medium', 'low', 'info'];

function Issues() {
  const [items, setItems] = useState([]);
  const [counts, setCounts] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const load = useCallback(async () => {
    setLoading(true); setError('');
    try {
      const res = await axios.get('/issues/');
      const sorted = (res.data.items || []).slice().sort((a, b) => ORDER.indexOf(a.severity) - ORDER.indexOf(b.severity));
      setItems(sorted);
      setCounts(res.data.counts || {});
    } catch (err) {
      setError(err.response?.data?.detail || err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
          <ProblemIcon color="warning" />
          <Typography variant="h4">Проблемы</Typography>
          {ORDER.map((s) => counts[s] ? (
            <Chip key={s} size="small" color={SEV[s].color} label={`${SEV[s].label}: ${counts[s]}`} />
          ) : null)}
        </Box>
        <Button variant="outlined" startIcon={<RefreshIcon />} onClick={load}>Пересканировать</Button>
      </Box>

      <Alert severity="info" sx={{ mb: 2 }}>
        Автоматические проверки против ошибок и халатности: IP-конфликты, дубли серийников, нехватка/пересортица
        на складе, истёкшая гарантия/срок службы, устройства без локации, открытый дрейф. Сканируется по запросу.
      </Alert>

      {error && <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError('')}>{error}</Alert>}

      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}><CircularProgress /></Box>
      ) : items.length === 0 ? (
        <Alert severity="success" icon={<OkIcon />}>Проблем не найдено — всё чисто.</Alert>
      ) : (
        <TableContainer component={Paper}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: 'bold' }}>Важность</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Проблема</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Объект</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Детали</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {items.map((it, i) => {
                const s = SEV[it.severity] || { label: it.severity, color: 'default' };
                return (
                  <TableRow key={i} hover>
                    <TableCell><Chip size="small" color={s.color} label={s.label} /></TableCell>
                    <TableCell>{it.title}</TableCell>
                    <TableCell>{it.entity_name || (it.entity_type ? `${it.entity_type}${it.entity_id ? ' #' + it.entity_id : ''}` : '—')}</TableCell>
                    <TableCell sx={{ color: 'text.secondary' }}>{it.detail || ''}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
}

export default Issues;
